export const CACHE_VERSION = "109.0";

export const SUPPORTED_LANGUAGES = ["ru", "uk", "en", "cs"];

export const FALLBACK_LANGUAGE = "en";
